import { type SearchRequest } from '@searchkit/api';
import { merge } from 'merge-anything';

import { bettingSplitsSourceFields } from '~/search-domain/pipelines/betting-splits/query-config';
import { type SearchDomainContext, type SearchRuntimeSortingOption } from '~/search-domain/types';
import { getSubeventBucketSize, SUBEVENT_TOTAL_AGGREGATION } from '~/search-domain/utils';

export function createQueryFactory(config: {
  activeSort: SearchRuntimeSortingOption;
  context: Pick<SearchDomainContext, 'isWalled'>;
  searchRequest: SearchRequest;
}) {
  const { activeSort, context, searchRequest } = config;

  const hitsPerPage = searchRequest.request.params?.hitsPerPage ?? 10;
  const page = searchRequest.request.params?.page ?? 0;

  const order = {
    [activeSort.field]: activeSort.order,
  };

  const sortAggregate = {
    [activeSort.field]: {
      max: {
        field: activeSort.field,
      },
    },
  };

  return merge(searchRequest, {
    body: {
      size: 0,
      aggs: {
        stable_total: SUBEVENT_TOTAL_AGGREGATION,
        subevents: {
          terms: {
            field: 'subeventId',
            size: getSubeventBucketSize({ hitsPerPage, isWalled: context.isWalled, page }),
            order,
            collect_mode: 'breadth_first' as const,
          },
          aggs: {
            ...sortAggregate,
            markets: {
              terms: {
                field: 'marketId',
                size: 10000,
              },
              aggs: {
                bets: {
                  terms: {
                    field: 'betId',
                    size: 10000,
                  },
                  aggs: {
                    best_odds: {
                      top_hits: {
                        _source: { includes: bettingSplitsSourceFields },
                        sort: {
                          oddsDecimal: 'desc' as const,
                        },
                        size: 1,
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  }) as SearchRequest;
}
